import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { UniversalLink } from '@plone/volto/components';
import { RichTextArticle } from 'design-comuni-plone-theme/components/ItaliaTheme/View';

const PersonaDipartimento = ({ content }) => {
  const intl = useIntl();
  const dipartimenti = content?.department;

  const showSection = content?.department?.length > 0;

  return showSection ? (
    <RichTextArticle
      tag_id="department"
      title={intl.formatMessage(messages.department)}
    >
      {dipartimenti?.map((dip) => {
        return (
          <div className="mb-5">
            <UniversalLink href={dip['@id']}>{dip.title}</UniversalLink>
          </div>
        );
      })}
    </RichTextArticle>
  ) : (
    <></>
  );
};
export default PersonaDipartimento;

const messages = defineMessages({
  department: {
    id: 'department',
    defaultMessage: 'Dipartimento',
  },
});
